import type { TextColor } from './Text.types';

export const textColorClassNames: Record<TextColor, string> = {
  accent: 'text-teal-700',
  disabled: 'text-neutral-500',
  error: 'text-red-700',
  inherit: '',
  inverse: 'text-white',
  muted: 'text-neutral-600',
  primary: 'text-neutral-1000',
  secondary: 'text-neutral-800',
  success: 'text-green-700',
  warning: 'text-yellow-700',
};
